import { LocalizedText } from "@/i18n/LocalizedText";
import * as React from "react";
import { cn } from "@/lib/utils";

function Loader({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="ai-loader"
      className={cn(
        "flex items-center gap-1.5 text-muted-foreground",
        className,
      )}
      {...props}
    >
      <span className="h-1.5 w-1.5 animate-bounce rounded-full bg-current [animation-delay:-0.2s]" />
      <span className="h-1.5 w-1.5 animate-bounce rounded-full bg-current [animation-delay:-0.1s]" />
      <span className="h-1.5 w-1.5 animate-bounce rounded-full bg-current" />
      <span className="sr-only">
        <LocalizedText id="legacy.loading.mmkrr7" />
      </span>
    </div>
  );
}

export { Loader };
